import AuthManager from "./AuthManager";
import AuthManagerNewAuth from "./AuthManagerNewAuth";


const kcPort = import.meta.env.VITE_KC_SAME_HOST_ON_PORT;
const kcUrl = kcPort ? 
    "http://" + location.host.split(":")[0] + ":" + kcPort
    : import.meta.env.VITE_KC_URL;


const kcClientId = import.meta.env.VITE_KC_CLIENT_ID || "web";
const kcRealm = import.meta.env.VITE_KC_REALM;
const kcGroup = import.meta.env.VITE_KC_GROUP;
const redirectUrl = import.meta.env.VITE_KC_REDIRECT_URL;
const useNewApi = import.meta.env.VITE_USE_NEW_AUTH;

function getAuthManager() {
    if(useNewApi) {
        console.log("USE NEW AUTH");
        return new AuthManagerNewAuth(kcUrl, {
            id: kcClientId,
            realm: kcRealm,
            group: kcGroup,
        }, redirectUrl || window.location.origin);    
    }
    else {
        console.log("USE DEFAULT AUTH");
        return new AuthManager(kcUrl, {
            id: kcClientId,
            realm: kcRealm
        }, redirectUrl || window.location.origin);
    }
}

const authManager = getAuthManager();

export default authManager;